// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xxbAJkajg0rtnYUHtEJi {
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.dNDg2PX1fqZO1JqlTGR8 {
  margin-bottom: 3rem;
}

.s4fWu2kjj7BF830Ft_QB {
  margin-bottom: 4rem;
}

.e3xxBwN87vAHZgUvLX37 {
  color: var(--grey-400);
}

.AO0dg_xI7h726durEi0T {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly
}

.AO0dg_xI7h726durEi0T > div {
    margin-top: 4rem;
  }

@media only screen and
  (max-width: 639px) {
  .AO0dg_xI7h726durEi0T {
    flex-direction: column
  }

    .AO0dg_xI7h726durEi0T > div {
      margin-top: 1rem;
      margin-bottom: 0;
    }

  .dNDg2PX1fqZO1JqlTGR8 {
    margin-bottom: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SearchResults/SearchResults.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf;AAKF;;AAHE;IACE,gBAAgB;EAClB;;AAGF;;EACE;IACE;EAMF;;IAJE;MACE,gBAAgB;MAChB,gBAAgB;IAClB;;EAGF;IACE,qBAAmB;EACrB;AACF","sourcesContent":[".searchResults {\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n}\n\n.title {\n  margin-bottom: 48px;\n}\n\n.productCardContainer {\n  margin-bottom: 64px;\n}\n\n.noResults {\n  color: var(--grey-400);\n}\n\n.resultsContainer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-evenly;\n\n  & > div {\n    margin-top: 64px;\n  }\n}\n\n@media (--mobile) {\n  .resultsContainer {\n    flex-direction: column;\n\n    & > div {\n      margin-top: 16px;\n      margin-bottom: 0;\n    }\n  }\n\n  .title {\n    margin-bottom: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchResults": `xxbAJkajg0rtnYUHtEJi`,
	"title": `dNDg2PX1fqZO1JqlTGR8`,
	"productCardContainer": `s4fWu2kjj7BF830Ft_QB`,
	"noResults": `e3xxBwN87vAHZgUvLX37`,
	"resultsContainer": `AO0dg_xI7h726durEi0T`
};
export default ___CSS_LOADER_EXPORT___;
